<template>
  <div>
    <header-navigation not-fixed />
    <main>
      <b-container class="my-3">
        <b-row>
          <b-col>
            <div class="mb-4">
              <h1 id="heading" class="mb-0">{{ $t('public.school_search.title') }}</h1>
              <p class="text-muted small m-0">
                {{ $t('public.school_search.description') }}
              </p>
            </div>

            <school-search @click="goActivate" />
          </b-col>
        </b-row>

        <!--      <notch-alert-->
        <!--        :description="$t('global.warning')"-->
        <!--        variant="warning"-->
        <!--        :design="2"-->
        <!--        class="fixed"/>-->
      </b-container>
    </main>
  </div>
</template>

<script>
import SchoolSearch from 'src/components/miscellaneous/ui/common/SchoolSearch.vue'
import HeaderNavigation from 'src/components/miscellaneous/ui/common/HeaderNavigation.vue'
import brandingMixin from 'src/mixins/branding/brandingMixin.js'

export default {
  name: 'LoginSelectSchool',
  components: { HeaderNavigation, SchoolSearch },
  mixins: [brandingMixin],

  methods: {
    goActivate(school) {
      if (!school) return

      this.$store.commit('schoolBranding/SET_BRANDING', school)
      this.$store.commit('SET_SLINK', school.slink)

      if (school.has_sdui === false) {
        return this.$router.push({
          name: 'marketing-user-type',
          query: { name: school.name },
          params: { uuid: school.uuid },
        })
      }
      this.$router.push({ name: 'login-sign-in', params: { slink: school.slink } })
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.timetable-bottom-message > .alert) {
  padding: 12px !important;
}
</style>
